import { AfterViewInit, Component, computed, inject, signal } from '@angular/core';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AnimationService } from '../../../services/animation.service';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';

interface FlagshipProject {
  img: string;
  sector: string;
  title: string;
  desc: string;
  progress: number;
  ministry: string;
  period: string;
}

@Component({
  selector: 'app-flagship-projects',
  imports: [...TRANSLATIONS_IMPORTS, CommonModule, RouterLink, ...MATERIAL_IMPORTS],
  templateUrl: './flagship-projects.html',
  styleUrl: './flagship-projects.scss',
})
export class FlagshipProjects implements AfterViewInit {
  private readonly animation = inject(AnimationService);

  ngAfterViewInit() {
    this.animation.scrollAnimate('.flagship-projects');
  }

  readonly sectors = [
    'All Sectors',
    'Infrastructure',
    'Health',
    'Education',
    'Agriculture',
    'Environment',
    'Social Protection',
  ];
  readonly activeSector = signal('All Sectors');

  readonly projects: FlagshipProject[] = [
    {
      img: 'assets/images/sgr-pic.jpeg',
      sector: 'Infrastructure',
      title: 'National Road Network Expansion — Phase II',
      desc: 'Connecting rural and urban centres through a 2,400 km development corridor under Vision 2050.',
      progress: 74,
      ministry: 'Ministry of Works',
      period: '2022–2026',
    },
    {
      img: 'assets/images/tz-edu.webp',
      sector: 'Education',
      title: 'Secondary Schools Infrastructure Upgrade Programme',
      desc: 'Rehabilitating 800 secondary schools with modern classrooms, labs, and digital learning tools.',
      progress: 58,
      ministry: 'MoEST',
      period: '2023–2027',
    },
    {
      img: 'assets/images/health-sector.jpeg',
      sector: 'Health',
      title: 'Universal Health Coverage & Facility Modernisation',
      desc: 'Expanding health access through 300 new facilities and upgraded diagnostic equipment nationwide.',
      progress: 42,
      ministry: 'MoH',
      period: '2024–2028',
    },
    {
      img: 'assets/images/plantation-tz.jpg',
      sector: 'Agriculture',
      title: 'Food Security & Irrigation Development Initiative',
      desc: 'Boosting food production through 1.2M hectares of new irrigation systems and farmer capacity building.',
      progress: 63,
      ministry: 'MoALF',
      period: '2021–2025',
    },
  ];

  readonly filtered = computed<FlagshipProject[]>(() => {
    const sector = this.activeSector();
    return sector === 'All Sectors' ? this.projects : this.projects.filter((p) => p.sector === sector);
  });
}
